const { isString } = require('./is-string')
const { usableValue } = require('./usable-value')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {*} x
 * @returns {*}
 */
function stringToInt (x) {
  if (!usableValue(x)) return
  if (!isString(x)) return x

  return parseInt(x.replace(/\s/g, '').trim())
}

module.exports = { stringToInt }
